module.exports = __webpack_public_path__ + "media/images/weather/330_night-3b04f096b2e013d8d962f02c53818055.png";